import { useEffect, useRef } from 'react';
import PropTypes from 'prop-types';

import { useOnScreen } from 'src/lib/hooks';

const propTypes = {
  className: PropTypes.string,
  onNotify: PropTypes.func.isRequired,
};

const defaultProps = {
  className: null,
};

export const OnVisibleNotifier = ({ className, onNotify }) => {
  const ref = useRef(null);
  const isVisible = useOnScreen(ref);

  useEffect(() => {
    onNotify(isVisible);
  }, [isVisible, onNotify]);

  return (
    <div
      className={className}
      ref={ref}
    />
  );
};

OnVisibleNotifier.propTypes = propTypes;
OnVisibleNotifier.defaultProps = defaultProps;

export default OnVisibleNotifier;
